import { Button } from '@calizahq/react-components-v2'
import { PotentialBookingsMutations } from '@sales-app/graphql/mutations/potentialBookings.mutations'
import React from 'react'

import { useAlertContext } from '@/context'
import { useMobile } from '@/hooks'
import { useGraphqlMutation } from '@/hooks/useGraphql'

type Props = {
  potentialBookingId: number
  potentialBookingStatusId: number
  refetch: () => void
  refetchPotentialBooking: () => void
  toggle: () => void
}

export const MarkAsLost = ({
  potentialBookingId,
  toggle,
  potentialBookingStatusId,
  refetch,
  refetchPotentialBooking,
}: Props) => {
  const { isTablet } = useMobile()
  const { setAlert } = useAlertContext()

  const updatePotentialBooking = () => {
    mutate({
      potentialBooking: {
        potentialBookingId,
        potentialBookingStatusId,
      },
    })
  }

  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(
    PotentialBookingsMutations.updatePotentialBooking(),
    {
      onSuccess: () => {
        setAlert(`Potential Booking ${potentialBookingId} marked as Lost.`, 'success')
        refetch()
        refetchPotentialBooking()
        toggle()
      },
    },
  )

  return (
    <div className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
      <h5 className="mb-4 text-header-xs leading-120">
        I am acknowledging that this Potential Booking is Lost after engaging with the Bookable Person.
      </h5>
      <div className="flex flex-col-reverse justify-between md:flex-row">
        <Button
          className="w-full bg-action-secondary md:flex md:w-auto"
          onClick={toggle}
          size={isTablet ? 'medium' : 'small'}
          variant="secondary"
        >
          Cancel
        </Button>
        <Button
          className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
          disabled={isMutationLoading}
          isLoading={isMutationLoading}
          onClick={updatePotentialBooking}
          size={isTablet ? 'medium' : 'small'}
        >
          Confirm
        </Button>
      </div>
    </div>
  )
}
